<template>
    <div class="loader" style="text-align: center;margin-bottom: 95px;">
        <div class="sk-circle green">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
        </div>
        <small style="color:rgb(117, 199, 145);">Az adatok lekérése folyamatban...</small>
    </div>
</template>
<script>
export default {};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CustomLoader.vue